import { render } from "./RecordAttendance.vue?vue&type=template&id=6db63ead&scoped=true"
import script from "./RecordAttendance.vue?vue&type=script&lang=js"
export * from "./RecordAttendance.vue?vue&type=script&lang=js"

import "./record-attendance.scss?vue&type=style&index=0&id=6db63ead&lang=scss&scoped=true"
import "./RecordAttendance.vue?vue&type=style&index=1&id=6db63ead&lang=css"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db63ead"]])

export default __exports__